import { render, staticRenderFns } from "./StatusEffective.vue?vue&type=template&id=453c63c3&"
import script from "./StatusEffective.vue?vue&type=script&lang=ts&"
export * from "./StatusEffective.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports